// @flow

export const DEFAULT_LANGUAGE = 'sk';
export const SHOW_LANGUAGE_SWITCHER = '0';
